import humanizeDuration from 'humanize-duration'
import { Duration } from 'pbts/google/protobuf/duration'
import { FC } from 'react'
import { IntlShape, useIntl } from 'react-intl'

const secondInMiliseconds = 1000
const minuteInMiliseconds = 60 * secondInMiliseconds
const hourInMiliseconds = minuteInMiliseconds * 60
const dayInMiliseconds = hourInMiliseconds * 24
const unitMeasures = {
    y: 365 * dayInMiliseconds,
    mo: 30 * dayInMiliseconds,
    w: 7 * dayInMiliseconds,
    d: dayInMiliseconds,
    h: hourInMiliseconds,
    m: minuteInMiliseconds,
    s: secondInMiliseconds,
}

export const RoundedDuration: FC<{duration?: Duration}> = ({
    duration,
}) => {
    const intl = useIntl()

    return roundedDurationString(intl, duration)
}

export const roundedDurationString = (intl: IntlShape, duration?: Duration): string => {
    if (!duration || duration.seconds === 0) {
        return intl.formatMessage({
            defaultMessage: 'Indefinite',
            id: 'indefinite_duration',
        })
    }

    const milliseconds = duration.seconds * secondInMiliseconds
    return humanizeDuration(Number(milliseconds), {
        unitMeasures,
    })
}
